import { IonContent, IonInput, IonLabel, IonPage } from "@ionic/react"
import { useState, useEffect } from "react"
import { Link, useHistory } from "react-router-dom"
import { Infologo } from "../Entryfile/imagepath"
import swal from 'sweetalert'
import service from "../Service/service"
import keycloak from "../lib/keycloak"

const ChangePassword: React.FC = () => {

    const history = useHistory()
    const [emailId, setEmailId] = useState("")
    const [oldpassword, setOldpassword] = useState("");
    const [newpassword, setNewpassword] = useState("")
    const [confrimNewpassword, setConfrimNewpassword] = useState("");
    const role = localStorage.getItem("UserRole");
    const Id = localStorage.getItem("SignupEmpId");
    const [token] = useState(localStorage.getItem("SignupEmpId"));
    useEffect(() => {
        if (token === null) {
            history.push("/login");
        } else {
        }
    }, [token, history]);

    const close = () => {
        history.goBack();
        // if (role === "TEAM_MEMBER") {
        //     history.push("/MemberAccess")
        // }
        // else if (role === "TEAM_LEADER") {
        //     history.push("/LeaderAccess")
        // }
        // else if (role === "MANAGER") {
        //     history.push("/ManagerAccess")
        // }
        // else if (role === "HR") {
        //     history.push("/Homepage")
        // }
    }
    const submit = async () => {
        if (oldpassword === "") {
            swal("", "Please Enter Your Old Password", "info");
            return;
        }
        if (newpassword === "") {
            swal("", "Please Enter Your New Password", "info");
            return;
        }
        if (confrimNewpassword === "") {
            swal("", "Please Confirm Your Password", "info");
            return;
        }
        if (newpassword !== confrimNewpassword) {
            swal("", "New password and confirm password do not match", "error");
            return;
        }

        try {
            const response = await service.ChangePassword(Id, oldpassword, newpassword, confrimNewpassword);
            const status = response?.data?.status ?? response?.status;

            if (status === 200 || status === "200") {
                swal("", "Password Changed Successfully", "success");


                const loginType = localStorage.getItem("loginType");

  if (loginType === "keycloak") {
    localStorage.clear();
window.location.href = process.env.REACT_APP_KEYCLOAK_LOGIN_URL;
  } else {
    localStorage.clear();

    window.location.href = "/login";
  }





                
            } else {
                swal("", response?.data?.message || "Failed to change password", "error");
            }
        } catch (error: any) {
            console.error("Change password failed:", error);
            swal("", error?.response?.data?.message || "Failed to change password", "error");
        }
    }

    return (
        <IonPage>
            <IonContent>
                <div className="account-content">
                    <div className="container">
                        <div className="account-logo">
                            <Link to="/">
                                <img src={Infologo} alt="INFOCAREER" />
                            </Link>
                        </div>
                        <div className="account-box">
                            <div className="account-wrapper">
                                <h3 className="account-title">Change Password</h3>
                                <div style={{ marginTop: "3%" }}>
                                    <div className="form-group">
                                        <IonLabel style={{ fontWeight: "bold" }}>Old Password <span className="text-danger">*</span></IonLabel>
                                        <IonInput onIonChange={(e: any) => setOldpassword(e.detail.value)} className="form-control" type="password" />
                                    </div>

                                    <div className="form-group">
                                        <IonLabel style={{ fontWeight: "bold" }}>New Password <span className="text-danger">*</span></IonLabel>
                                        <IonInput onIonChange={(e: any) => setNewpassword(e.detail.value)} className="form-control" type="password" />
                                    </div>

                                    <div className="form-group">
                                        <IonLabel style={{ fontWeight: "bold" }}>Confirm New Password <span className="text-danger">*</span></IonLabel>
                                        <IonInput onIonChange={(e: any) => setConfrimNewpassword(e.detail.value)} className="form-control" type="password" />
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group text-center">
                                                <button
                                                    className="btn btn-primary account-btn"
                                                    type="submit"
                                                    onClick={submit}
                                                >
                                                    Submit
                                                </button>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group text-center">
                                                <button
                                                    className="btn btn-primary account-btn"
                                                    type="button"
                                                    onClick={close}
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </IonContent>
        </IonPage>
    )
}

export default ChangePassword;